import type { MenuProps as BaseMenuProps } from "antd";
import { Menu as BaseMenu } from "antd";
import { FC, useEffect, useState } from "react";
import { Report, getReports } from "../../services/reports";

export type MenuProps = {
  setReportType: (report: string, title: string) => void;
};

const Menu: FC<MenuProps> = ({ setReportType }) => {
  const [current, setCurrent] = useState<string>("");
  const [reports, setReports] = useState<Report[]>([]);

  const onClick = (link: string, name: string) => {
    setReportType(link, name);
    setCurrent(link);
  };

  useEffect(() => {
    const initialize = async () => {
      const reports = await getReports();
      setReports(reports);
    };

    initialize();
  }, []);

  return (
    <div className="report-menu">
      <BaseMenu activeKey={current} mode="horizontal" style={{
        position: "absolute",
        right: 100
      }} >
        {reports.map((report) => (
          <BaseMenu.SubMenu key={report.key} title={report.name}>
            {report.childs?.map((child) => (
              <BaseMenu.Item key={child.link} onClick={() => onClick(child.link, child.name)}>
                {child.name}
              </BaseMenu.Item>
            ))}
          </BaseMenu.SubMenu>
        ))}
      </BaseMenu>
    </div>
  );
};

export default Menu;
